import React, { useState,  useRef } from "react";
import { connect } from 'react-redux'
import { BiEdit } from "react-icons/bi";
import { RiDeleteBin6Line } from "react-icons/ri";
import { Button, Form, Modal } from "react-bootstrap";
import AgGridTable from "../AgGridTable";
import {
    addStatutoryIndustryAction,
    updateStatutoryIndustryAction,
    deleteStatutoryIndustryAction
} from '../../../redux/actions/admin/adminAction';
import Select from "react-select";
import { groupdata } from '../helper/index'

export const StatutoryIndustryTraining = (props) => {
    const gridRef = useRef();

    const [inputData, setInputData] = useState({ 'statutory_training': '', 'sector': '', 'score': '' })
    const [show, setShow] = useState(false);

    const customStyles = {
        control: (base, state) => ({
            ...base,
            top: "5px",
            // Overwrittes the different states of border
            borderColor: state.isFocused ? "#309CCA" : "#309CCA",
        }),
    };

    const handleShow = () => {
        setShow(true);
    }

    const handleClose = () => {
        setInputData({ 'statutory_training': '', 'sector': '', 'score': '' })
        setShow(false)
    };

    const handleSeclect = (event) => {
        setInputData((prevstate) => ({
            ...prevstate,
            ['sector']: event.id
        }))
    }


    const handleChange = (event, name) => {
        setInputData((prevstate) => ({
            ...prevstate,
            [event.target.name]: event.target.value
        }))
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        if (inputData['id']) {
            props.updateStatutoryIndustry(inputData.id, inputData)
            handleClose()
        }
        else {
            props.addStatutoryIndustry(inputData)
            handleClose()
        }
    };

    const handleSetData = (data) => {
        setInputData(data)
        handleShow()
    }

    const handleDelete = (id) => {
        props.deleteStatutoryIndustry(id)
    }


    const [statutoryColumnDefs] = useState([
        { headerName: "Id", field: 'id', sort: 'asc' },
        { headerName: "Statutory Industry Training", field: 'statutory_training', filter: true, },
        { headerName: "Sector", field: 'sector_name', filter: true },
        { headerName: "Score", field: 'score', filter: true, },
        {
            headerName: "Actions", field: 'action',
            cellRendererFramework: (params) => <>
                <BiEdit color="blue" size={20} onClick={() => handleSetData(params.data)} cursor='pointer' />
                <RiDeleteBin6Line color="red" size={20} onClick={() => handleDelete(params.data.id)} cursor='pointer' />
            </>,
            cellStyle: { textAlign: 'center' }
        },
    ])

    const defaultColDef = {
        flex: 1,
        floatingFilter: true,
        sortable: true,
        editable: false,
    }

    return (
        <div>
            <div align='right'>
                <button className="btn btn-blue"
                    onClick={() => handleShow()}
                    style={{ marginBottom: "10px" }}>Add</button>
            </div>

            <AgGridTable
                ref={gridRef}
                data={groupdata(props.sector, props.statutoryIndustry, 'sector', 'sector_name')}
                defaultColDef={defaultColDef}
                columnDefs={statutoryColumnDefs} />

            {/* Add Form */}
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Statutory Industry Training</Modal.Title>
                </Modal.Header>

                <form onSubmit={handleSubmit}>
                    <Modal.Body>
                        <h3>Statutory Industry</h3>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="statutory_training"
                                name="statutory_training"
                                value={inputData.statutory_training}
                                onChange={handleChange}
                                placeholder="Statutory Industry Training"
                                autoComplete="off"
                            />
                        </div>
                        <br></br>
                        <h3>Sector</h3>
                        <div className="">
                            <Select
                                id="sector"
                                name="sector"
                                options={props.sector}
                                value={inputData.sector ?
                                    props.sector.find(
                                        (row) =>
                                            row.id === inputData.sector) :
                                    null
                                }
                                getOptionLabel={(option) => option.sector}
                                getOptionValue={(option) => option.id}
                                onChange={(event) => handleSeclect(event)}
                                placeholder="Choose.."
                                isClearable={true}
                                styles={customStyles}

                            />
                        </div>
                        <br></br>
                        <h3>Score</h3>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="score"
                                name="score"
                                value={inputData.score}
                                onChange={handleChange}
                                placeholder="Score"
                                autoComplete="off"
                            />
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Cancel
                        </Button>
                        <Button variant="primary" type="submit">
                            Submit
                        </Button>
                    </Modal.Footer>

                </form>
            </Modal>
        </div >
    )
}

const mapStateToProps = (state) => {
    const statutoryIndustry = state.admin.statutoryIndustry;
    const sector = state.admin.sector;

    return {
        statutoryIndustry: statutoryIndustry,
        sector: sector,
    };
};

const mapDispatchToProps = (dispatch, state) => {
    return {
        addStatutoryIndustry: (data) => dispatch(addStatutoryIndustryAction(data)),
        updateStatutoryIndustry: (id, data) => dispatch(updateStatutoryIndustryAction(id, data)),
        deleteStatutoryIndustry: (id) => dispatch(deleteStatutoryIndustryAction(id)),

    };
};



export default connect(mapStateToProps, mapDispatchToProps)(StatutoryIndustryTraining)

